import { DOCUMENT } from '@angular/common'
import { InjectionToken, inject } from '@angular/core'

/**
 * FR-051 U7 (AC-8.6, AC-N1.3) — framed mode: the portal is shown inside an
 * iframe (a same-site page of the agency's own domain). Browser-only and
 * layout-only: never sent to or trusted by the server — the server's
 * `frame-ancestors` (U10) decides WHO may frame us; this only trims the chrome.
 */

/** Is `win` inside a frame? A cross-origin parent makes `top` throw → framed. */
export function isFramed(win: Window | null | undefined): boolean {
  if (!win) return false
  try {
    return win.top !== win.self
  } catch {
    return true
  }
}

/** Framed mode for this document (a token, so specs can set it). */
export const IS_FRAMED = new InjectionToken<boolean>('IS_FRAMED', {
  providedIn: 'root',
  factory: () => isFramed(inject(DOCUMENT).defaultView),
})

/** App initializer: `<html class="framed">` while framed (layout hooks only). */
export function initFramedMode(): void {
  if (inject(IS_FRAMED)) inject(DOCUMENT).documentElement.classList.add('framed')
}
